export function getBarLength(resolution) {
    return parseInt(resolution.numSteps()) / 4;
}
